import { IFilter } from "@/api";
import { INITIAL_FILTER_MODEL } from "@/config/constants";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid-pro";
import { isArray } from "lodash";
import { useCallback, useState } from "react";

export const useFilterModel = (
    initialFilterModel: IFilter = INITIAL_FILTER_MODEL
) => {
    const [filterModel, setFilterModel] = useState<IFilter>(initialFilterModel);

    // Handles when a filter or sort is applied to the data grid
    const handleFilterModelChange = useCallback(
        (newFilterModel: GridFilterModel | GridSortModel) => {
            if (isArray(newFilterModel)) {
                const sortModel = newFilterModel as GridSortModel;
                if (sortModel.length > 0 && sortModel[0].sort) {
                    setFilterModel({
                        sort_by: sortModel[0].field,
                        order: sortModel[0].sort,
                    });
                }
            } else {
                const filterModel = newFilterModel as GridFilterModel;

                // If the filter model is empty, reset the filter model to the initial filter model
                if (filterModel.items.length === 0) {
                    // If being used for quick filter
                    if (
                        filterModel.quickFilterValues &&
                        filterModel.quickFilterValues.length > 0
                    ) {
                        setFilterModel({
                            q: filterModel.quickFilterValues.join(" "),
                            sort_by: "quick",
                        });
                        return;
                    }

                    setFilterModel(INITIAL_FILTER_MODEL);
                    return;
                }

                setFilterModel({
                    q: filterModel.items[0].value as string,
                    sort_by: filterModel.items[0].field,
                    order: "desc",
                });
            }
        },
        []
    );

    const resetFilterModel = useCallback(() => {
        setFilterModel(initialFilterModel);
    }, [initialFilterModel]);

    return {
        filterModel,
        handleFilterModelChange,
        resetFilterModel,
    };
};
